<template>
    <div class="EndorsementReview">
        <MatchingSelectionReviewBase
            provided-subject-title="Form Number"
            matching-subject-title="Category"
            no-matches-text="Additional Insured Endorsement, Category not listed"
            :provided="actionDetails.formNumber"
            :action-review="actionReview"
            :read-only="readOnly"
            :matching-list="endorsementCategories"
            @resolve="onResolve"
        />
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from '@evidentid/vue-property-decorator';

    import { typeNarrowing } from '@evidentid/dashboard-commons/utils/typeNarrowing';
    import {
        ActionReview,
        ActionType, EndorsementFormNumberActionDetails,
        EndorsementFormNumberActionResolveInput,
    } from '@evidentid/tprm-portal-lib/models/entity-actions-review';

    import MatchingSelectionReviewBase
        from '@/modules/entity-actions-review/components/MatchingSelectionReviewBase/MatchingSelectionReviewBase.vue';
    import { WRONG_ACTION_DETAILS_TYPE_MESSAGE } from '@/modules/entity-actions-review/constants';

    @Component({
        emits: [ 'resolve' ],
        components: { MatchingSelectionReviewBase },
    })
    export default class EndorsementReview extends Vue {
        @Prop({ type: Boolean, default: false })
        private readOnly!: boolean;

        @Prop({ type: Object, default: () => ({}) })
        private actionReview!: ActionReview;

        @Prop({ type: Array, default: () => [] })
        private endorsementCategories!: string[];

        private get actionDetails(): EndorsementFormNumberActionDetails {
            return typeNarrowing(
                this.actionReview.action,
                this.actionReview.action.$action === ActionType.endorsementFormNumberV1,
                WRONG_ACTION_DETAILS_TYPE_MESSAGE,
            );
        }

        private onResolve(val: string | null): void {
            const data: EndorsementFormNumberActionResolveInput = {
                $action: ActionType.endorsementFormNumberV1,
                category: val,
            };
            this.$emit('resolve', data);
        }
    }
</script>
